<template>
  <div
    class="content-flex-row"
    :style="_style"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import {SogAlign} from "@/shared/ui/types/SogAlign";
import {computed} from "vue";

interface Props {
  alignX?: SogAlign
  alignY?: SogAlign
}

const props = withDefaults(defineProps<Props>(), {alignX: undefined, alignY: undefined}
)

const _style = computed(() => {
  let res = "";
  if (props.alignX) {
    res += "justify-content: " + props.alignX + ";"
  }
  if (props.alignY) {
    res += "align-items: " + props.alignY + ";"
  }
  return res;
})


</script>
<!--
//  column-gap: 1em;

-->

<style>
.content-flex-row {
  margin-top: 10px;
  justify-content: center;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 5px;
  row-gap: 5px;
  overflow-x: auto;
}

.content-flex-column {
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 5px;
  column-gap: 5px;
  flex-wrap: wrap;
}

</style>
